<template>
  <div class="c-full-card">
    <div class="c-full-card__inner">
      <div class="c-full-card__bg">
        <Picture 
          from="asset"
          :src="src" 
          :ratio="ratio"
          type="bg"
        />
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Picture from "@/parts/picture/PictureView.vue";

export default {
  components: {
    Picture,
  },
  props: {
    src: {
      type: String,
      default: '',
    },
    ratio: {
      type: String,
      default: '96x120'
    }
  }
}
</script>

<style>

</style>